import { action } from 'mobx';
import jump from 'jump.js';

import { AppManager, Variables } from 'core/index';

import { clientStore } from 'apps/client/app';
import { ProfileModel, ProfileApp } from 'apps/profile/app';

import { ActivityConnManager } from 'apps/home/activityFeed/connManager';
import {
  GlobalActivityFeedQuery,
  ContributedProjectsQuery,
} from 'apps/home/activityFeed/gql';

export class GlobalActivityManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('contributedProjects', ProfileApp);

    this.activitiesConn = new ActivityConnManager(this, {
      loadMoreQuery: GlobalActivityFeedQuery,
    });
    this.variables = new Variables({
      username: () => clientStore.signedInProfile.username,
    });
    this.MyFeedQuery();
  }

  @action MyFeedQuery = () => {
    this.activitiesConn.loadMore();
    this.NewProjectsQuery();
  };

  @action NewProjectsQuery = () => {
    const q = new ContributedProjectsQuery(this, {
      queryKey: 'contributedProjects',
      onSysErr: this.onProfileError,
    });
    q.process(profile => ProfileModel.Load(profile), this.ProjectsUpdate);
    q.query();
  };

  @action ProjectsUpdate = profileModel => {
    this.contributedProjects = profileModel;
  };

  @action SetActiveTab = tabName => {
    if (tabName === 'myFeed') {
      clientStore.routerStore.navigate('home.activity');
    } else {
      jump('#app', { offset: -100 });
    }
  };
}
